import {Flex, Text, useColorModeValue} from "@chakra-ui/react";
import Card from "../../../components/Card/Card.js";
import CardBody from "../../../components/Card/CardBody.js";
import React from "react";
import { useTranslation } from 'react-i18next';

const Location = () => {
  const { t } = useTranslation('contact');
  const textColor = useColorModeValue("gray.700", "white");
  const whiteTextColor = useColorModeValue("white", "white");

  return (
    <Card p="16px">
      <CardBody>
        <Flex direction="column" w="100%">

          <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
            <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
              {t('contact:subtitle')}
            </Text>
            <Text fontSize="md" fontWeight="medium" color="gray.400">
              <Text
                as="span"
                color={"green.400"}
                fontWeight="bold"
              >
              </Text>{" "}
              {t('contact:response')}
            </Text>
          </Flex>


          <Card
              py="1rem"
              width="100%"
              bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
              position="relative"
          >
            <Text fontSize="lg" color={whiteTextColor} fontWeight="bold" mb="6px">
              {t('contact:korea')}
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-home"></i>  236, Jubuto-ro, Bupyeong-gu, Incheon, Korea (Techno Valley U1 Center) C-807</li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-home"></i>  인천광역시 부평구 주부토로 236 테크노밸리U1센터 C동 807호 </li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-phone"></i>  +82 10 6309 7346</li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><a href="mailto:tgcam@naver.com"><i className="fa fa-envelope"></i>tgcam@naver.com</a></li>
            </Text>

            <br/>
            <Text fontSize="lg" color={whiteTextColor} fontWeight="bold" mb="6px">
             {t('contact:china')}
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-home"></i>  801F,NO.2, xinweicun xili Nanshan district Shenzhen city,Guangdong
                province,China(518055)
              </li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-home"></i>  南山区西丽街道新围村2号楼801室</li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><i className="fa fa-phone"></i>  +86 18682370991</li>
            </Text>
            <Text fontSize="sm" color={whiteTextColor} mb="6px">
              <li><a href="mailto:leeguohang@126.com"><i className="fa fa-envelope"></i>leeguohang@126.com</a></li>
            </Text>

          </Card>

          <Card py="1rem" width="100%" position="relative" mt="20px">
            <iframe
              title="TG Cam Korea Office"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3166.2!2d126.7268!3d37.5159!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDMwJzU3LjEiTiAxMjbCsDQzJzM2LjUiRQ!5e0!3m2!1sko!2skr!4v1"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </Card>
        </Flex>

      </CardBody>
    </Card>
  );
};

export default Location;
